import { SortingDirection } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import {
	ItemsProviderWithStoreProps,
} from '@common/react/components/Core/ItemsProviderWithStore/ItemsProviderWithStore';

import { AppointmentType } from '@commonTuna/react/objects/AppointmentType';

type pickProperties = 'defaultSort' | 'filterHandler' | 'sortHandler' | 'storeName' | 'loadRequest' | 'pagination'
	| 'filters';

export const defaultOptions: Pick<ItemsProviderWithStoreProps<AppointmentType>, pickProperties> = {
	defaultSort: ['sortOrder', SortingDirection.Ascending],
	filterHandler: () => true,
	sortHandler: (a, b) => (a.sortOrder - b.sortOrder),
	storeName: 'appointmentTypes',
	loadRequest: 'appointmentType',
	pagination: { current: 1, pageSize: 100 },
	filters: {
		column: [{ caption: 'sortOrder', direction: SortingDirection.Ascending }],
		count: 100,
	},
};
